import {ValidationQuestion} from 'features/CreateAccount/enums';

const validationOptionsHasOption = (validationOptions: string[], option: ValidationQuestion) =>
  validationOptions.some((item: string) => item === option);

export const hasSSNOption = (validationOptions: string[]) =>
  validationOptionsHasOption(validationOptions, ValidationQuestion.SSN);

export const hasDLOption = (validationOptions: string[]) =>
  validationOptionsHasOption(validationOptions, ValidationQuestion.DRIVER_LICENSE);

export const hasValidationOption = (validationOptions: string[]) =>
  hasSSNOption(validationOptions) || hasDLOption(validationOptions);
